import React, { Component } from 'react';
import "./Login.css"
import Api from '../api/api';
import intl from 'react-intl-universal';
import Select from 'react-select';




export default class Login extends Component {
  constructor(props) {
    super();
    this.state = {
      staff_number: '18918856483',
      qs: '',
      errorInfo: null,
      demo: '',
      selectedOption:{ value:'zh' , label: intl.get('txt_chinese') },
    };
    this.submit = this.submit.bind(this);
  }

  render() {

    const options = [
      { value:'zh' , label: intl.get('txt_chinese') },
      { value:'en', label: intl.get('txt_english') },
      {value:'ms',label:intl.get('txt_malay')}
    ];
    const { selectedOption } = this.state;
    return (
      <div>            
        <div className="login">

          <img className="logo" src={require('../assets/logo.png')} alt="" />
          <div className="form">
    
            {/*<input type="text" value={this.state.demo} onChange={event=>this.setState({demo: event.target.value})} placeholder="请输入商户号"/>*/}
            <input type="text" value={this.state.qs} onChange={event => this.setState({ qs: event.target.value })} placeholder={intl.get('qsrsph')} />
            {/*<input type="text" value={this.state.demo} onChange={event=>this.setState({demo: event.target.value})} placeholder="请输入商户号"/>*/}
            {
              this.state.errorInfo && (
                <div style={{ color: '#FF5230', textAlign: 'left' }}>{this.state.errorInfo}</div>
              )
            }
            <button className="button" onClick={this.submit}>{intl.get('txt_qd')}</button>
          </div>
        </div>
       <div className='select' >
       <Select
        isSearchable={false}
        value={selectedOption}
        onChange={this.handleChange}
        options={options}
      />
       </div>
      </div>
    )
  }
  handleChange = selectedOption => {
    intl.options.currentLocale = selectedOption.value;
    this.forceUpdate() 
    this.setState(
      { selectedOption:selectedOption },
      () => {        
        console.log(`Option selected:`, this.state.selectedOption)}
    );
  };
  submit() {
    /*	
    if(this.state.qs === '' || this.state.staff_number === ''){
      this.setState({errorInfo:'信息填写不完整'})
      return
    }
    */
    Api.getRecords({
      qs: this.state.qs,
      staff_number: this.state.staff_number
    }).then(res => {

      if (res.data.code === 0) {
        console.log(res.data.data);

        if (res.data.data.total > 0) {

          this.props.history.push(`/record/?qs=${this.state.qs}&staff_number=${this.state.staff_number}`)
          return;
        }
        this.setState({ errorInfo: intl.get('txt_NoData') })
      } else {
        this.setState({ errorInfo: res.data.message })
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/views/Login.jsx